import { Injectable, Inject, DOCUMENT, NgZone } from '@angular/core';

// Lets minimal scrollbars fade out while unused: once enabled, any element that
// scrolls is marked .is-scrolling until it has been still for a moment. The
// styles (scss/_scrollbar.scss) only fade under html.scrollbar-fade, so apps
// that don't enable this keep their scrollbars visible.
@Injectable({
  providedIn: 'root'
})
export class ScrollbarFadeService {

  // how long a scrollbar stays visible after the last scroll, before it fades out
  private holdMs = 800;

  private isEnabled = false;

  private timeouts = new WeakMap<Element, any>();

  constructor(
    @Inject(DOCUMENT) private document: any,
    private zone: NgZone) { }

  enable() {

    if (this.isEnabled || typeof window === 'undefined') return;
    this.isEnabled = true;

    this.document.documentElement.classList.add('scrollbar-fade');

    // scroll events don't bubble, but they pass the document while capturing;
    // outside the zone, as they only toggle a class
    this.zone.runOutsideAngular(() =>
      this.document.addEventListener('scroll', (e: Event) => this.onScroll(e), { capture: true, passive: true }));
  }

  private onScroll(e: Event) {

    var element = e.target === this.document ? this.document.documentElement : e.target;
    if (!(element instanceof Element)) return;

    element.classList.add('is-scrolling');

    clearTimeout(this.timeouts.get(element));
    this.timeouts.set(element, setTimeout(() => element.classList.remove('is-scrolling'), this.holdMs));
  }
}
